import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import BootstrapVue from 'bootstrap-vue'
import firebase from 'firebase/app'

Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: "AIzaSyD9ck9UefkZrSxd19kdPR_sPTbpOBKpdqs",
  authDomain: "readytextme.firebaseapp.com",
  databaseURL: "https://readytextme.firebaseio.com",
  projectId: "readytextme",
  storageBucket: "readytextme.appspot.com",
  messagingSenderId: "57918422653"
});

export const db = firebase.firestore();

Vue.use(BootstrapVue);

let app;
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});